import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const SNACKBAR_CONFIG: MatSnackBarConfig = {
  duration: 2000,
  panelClass: 'nv-mat-snackbar',
  horizontalPosition: 'left',
  verticalPosition: 'bottom',
};
